<template>
<div class="login-root">

  <!-- 移动端：直接复用与 client 页完全一致的 ClientLogin 组件，统一一套登录 UI（桌面端分屏见下方 v-else） -->
  <client-login v-if="innerWidth <= 730" @success="onClientLoginSuccess" />

  <!-- 【P117】桌面端登录：改用 .login-card 一套样式（原先的 .Login/.content-* 没有任何 CSS，
       所以渲染成裸块、非常丑；文件里其实早就有这套新样式，只是没用上） -->
  <div v-else class="Login">
    <div class="login-card">
      <div class="logo"><span>数字化管理系统</span></div>
      <p class="cl-greeting-m">使用员工账号登录以继续使用</p>

      <div class="form-item">
        <label>手机号</label>
        <div class="input-wrap">
          <input
            v-model="form.phone"
            type="tel"
            maxlength="11"
            placeholder="请填写手机号"
            autocomplete="username"
          />
        </div>
      </div>

      <div class="form-item">
        <label>密码</label>
        <div class="input-wrap">
          <input
            v-model="form.password"
            :type="pwdVisible ? 'text' : 'password'"
            placeholder="请输入密码"
            autocomplete="current-password"
            @keyup.enter="login('password')"
          />
          <span class="eye-icon" @click="pwdVisible = !pwdVisible">{{ pwdVisible ? '🙈' : '👁' }}</span>
        </div>
      </div>

      <button class="login-btn" :disabled="loginLoading" @click="login('password')">
        {{ loginLoading ? '登录中…' : '登 录' }}
      </button>

      <div class="link-row">
        <a @click="loginType='forget'">忘记密码</a>
        <a>联系管理员开通账号</a>
      </div>
    </div>
  </div>

    <el-dialog :visible.sync="wxBindingDialog" width="500px" @closed="closeBinding()">

        <el-tabs v-model="wxBindingBindType" style="margin:0px 0px 20px 0px">
            <el-tab-pane label="注册新账号"    name="register"></el-tab-pane>
            <el-tab-pane label="绑定已有账号"  name="bind"></el-tab-pane>
        </el-tabs>

        <el-form v-if="wxBindingBindType=='bind'" :rules="rules" ref="ruleForm" :model="form">
            <div class="logininputbox">
              <div class="el-form-item" prop="phone">
                <div class="el-form-item__content">
                  <el-input v-model="form.phone" placeholder="请填写手机号" maxlength="11"></el-input>
                </div>
              </div>
            </div>
            <div class="logininputbox">
              <div class="el-form-item is-required">
                <div class="el-form-item__content">
                  <el-input v-model="form.verificationcode" placeholder="请输入验证码"></el-input>
                  <div class="BindinCode BindinCodeBlue" @click="getCode" v-if="showCode">获取验证码</div>
                  <div class="BindinCode" v-else>{{ times }}s后重新获取</div>
                </div>
              </div>
            </div>
            <div class="el-form-item">
              <div class="el-form-item__content">
                <el-button type="primary" style="font-size: 18px;" @click="login('wx')" >绑定已有账号</el-button>
              </div>
            </div>
        </el-form>

        <el-form v-if="wxBindingBindType=='register'"  :rules="rules" ref="ruleForm" :model="form">
            <div class="logininputbox">
              <div class="el-form-item" prop="phone">
                <div class="el-form-item__content">
                  <el-input v-model="form.phone" placeholder="请填写手机号" maxlength="11"></el-input>
                </div>
              </div>
            </div>
            <div class="logininputbox">
              <div class="el-form-item" prop="password">
                <div class="el-form-item__content">
                  <el-input v-model="form.password" type="password" placeholder="设置密码"></el-input>
                </div>
              </div>
            </div>
            <div class="logininputbox">
              <div class="el-form-item is-required">
                <div class="el-form-item__content">
                  <el-input v-model="form.verificationcode" placeholder="请输入验证码"></el-input>
                  <div class="BindinCode BindinCodeBlue" @click="getCode" v-if="showCode">获取验证码</div>
                  <div class="BindinCode" v-else>{{ times }}s后重新获取</div>
                </div>
              </div>
            </div>
            <div class="el-form-item">
              <div class="el-form-item__content">
                <el-button type="primary" style="font-size: 18px;" @click="onRegister" >注册新账号</el-button>
              </div>
            </div>
            <div class="buttons">
              <span v-if="loginType=='register'">注册即表示同意《商城注册协议》《隐私权政策》</span>
            </div>
        </el-form>

		</el-dialog>
  </div>

</div>
</template>

<script>

  import {
    getAccountByPassword,
    registerCode,
    registerend,
    loginCode,
    loginByCode,
    getLoginUrl,
    testCode2,
    getTokenByState,
    getCodeForWxBinding,
    wxBindingUser
  } from "../api/login.js";
  import {getStaff} from "@/api/staff.js";
  import ClientLogin from "@/components/ClientLogin.vue";
  import { getAppScope, clientPasswordLogin, fetchProfile } from "@/util/clientAuth.js";
  export default {
    name: "login",
    data() {
      return {
        innerWidth:0,
        /* 【P117】桌面端登录：密码可见切换 + 按钮 loading（防重复提交） */
        pwdVisible:false,
        loginLoading:false,
        loginType: 'password',
        times: 10,
        showCode: true,
        wxData:null,
        wxState:null,
        wxStateTimer:null,
        wxBindingDialog:false,
        wxBindingBindType:null,
        wxBindingBindViewClose:true,
        loginView:false,
        form: {
          phone: '',
          password: '',
          pcode:'',
          verificationcode: ''
        },
        rules: {
          phone: [{
              required: true,
              message: '请输入手机号',
              trigger: 'blur'
            },
            {
              min: 11,
              max: 11,
              message: '手机号格式错误',
              trigger: 'blur'
            }
          ],
          password: [{
            required: true,
            message: '请输入密码',
            trigger: 'blur'
          }]
        }
      };
    },
    components: {
      ClientLogin
    },
    mounted() {
      let timestamp = new Date().getTime();
      this.form.timestamp = timestamp;
      if (this.$route.query.code) {
        this.form.pcode=this.$route.query.code;
      }
      this.innerWidth=window.innerWidth;

    },
    methods: {
      handleBindClick(){

      },

      // 【P94-fix】登录后统一按「角色端」分流（桌面端 / 移动端共用同一份判据）
      // 市场人员 → /market，财务人员 → /finance，运营人员 → /operation
      // 返回 true 表示已按端跳转；false 表示普通销售等，交给调用方走原本的兜底跳转
      routeByScope(profile) {
        const scope = (profile && profile.app_scope) || getAppScope();
        if (scope === 'market') {
          this.$router.push({ path: "/market" });
          return true;
        }
        if (scope === 'finance') {
          this.$router.push({ path: "/finance" });
          return true;
        }
        if (scope === 'operation') {
          this.$router.push({ path: "/operation" });
          return true;
        }
        return false;
      },

      // 移动端 ClientLogin 登录成功：token 已由组件写入，按「角色端」分流（P44 / P93）
      onClientLoginSuccess(token, profile) {
        if (this.routeByScope(profile)) { return; }
        // 该组件只在 innerWidth <= 730 时渲染，兜底即移动端销售首页
        this.$router.push({ path: "./client" });
      },
      changeLogin(type) {
        this.loginType = type
        console.log(window.innerWidth);
      },

      // 获取验证码
      getCode() {

        if (this.form.phone == '') {
            this.$message({
              message: '手机号不能为空',
              type: 'warning'
            });
            return;
        } 

        if (this.loginType == 'register' || this.wxBindingBindType=='register') {
          let data = {
            phone: this.form.phone,
            password: this.form.password,
          }
          registerCode(data).then(response => {
              if (response.code == 200) {
                this.showCode = false
                this.timer = setInterval(() => {
                  this.times--
                  if (this.times === 0) {
                    clearInterval(this.timer)
                    this.showCode = true
                    this.times=60
                  }
                }, 1000)
              }
            })
            .catch(error => {
              console.log(error);
            })
        }

        if (this.loginType == 'code') {
           let data = {
              phone: this.form.phone
            }
            loginCode(data).then(response => {
                if (response.code == 200) {
                  this.showCode = false
                  this.timer = setInterval(() => {
                    this.times--
                    if (this.times === 0) {
                      clearInterval(this.timer)
                      this.showCode = true
                      this.times=60
                    }
                  }, 1000)
                }
              })
              .catch(error => {
                console.log(error);
            })

        }

        if(this.loginType == 'wx' && this.wxBindingBindType=='bind'){
            if (this.form.phone != '') {
            let data = {
              phone: this.form.phone
            }
            getCodeForWxBinding(data).then(response => {
                if (response.code == 200) {
                  this.showCode = false
                  this.timer = setInterval(() => {
                    this.times--
                    if (this.times === 0) {
                      this.showCode = true
                      clearInterval(this.timer)
                      this.times=60
                    }
                  }, 1000)
                }
              })
              .catch(error => {
                console.log(error);
              })
          } else {
            this.$message({
              message: '手机号不能为空',
              type: 'warning'
            });
          }
        }

      },

      // 登录
      login(type) {
        if (type == 'password') {
          this.loginLoading = true;
          // 【P94-fix】桌面端登录此前只写 token、不做任何角色分流，
          // 于是市场/财务/运营账号在 PC 浏览器（>730px）登录后会掉进销售端页面。
          // 改为与移动端复用同一套 clientPasswordLogin + fetchProfile + routeByScope。
          clientPasswordLogin({
              phone: this.form.phone,
              password: this.form.password,
              remember: true
          }).then(response => {
              if (response && response.code == 200) {
                  localStorage.setItem("page", 0);
                  /* 【P117 修复】桌面端恢复「按屏幕宽度分流」的原有登录逻辑。
                     P94 曾给桌面端也加上 routeByScope(profile)，于是市场/财务/运营账号
                     在 PC（>800px）登录后被推到 /market /finance /operation —— 那三个都是
                     **H5 端页面**，表现就是「PC 登录后跳到 H5」。
                     现恢复：桌面 → /home/enterprise（PC 端）；窄屏 → ./client（H5）。 */
                  return fetchProfile(true).then(profile => {
                      if (window.innerWidth < 800) {
                          this.$router.push({
                          path: "./client"
                        });
                      } else {
                        this.$router.push({
                          path: "./home/enterprise"
                        });
                      }
                      setTimeout(() => {
                        this.loginView = true;
                        //this.getStaff();
                      }, 1000);
                  });
              }
              if (this.$message && response && response.msg) {
                  this.$message.error(response.msg);
              }
          })
          .catch(error => {
              console.log(error);
          })
          .finally(() => { this.loginLoading = false; })
        }
        if (type == 'code') {
          loginByCode({
              phone: this.form.phone,
              code: this.form.verificationcode,
            }).then(response => {
              if (response.code == 200) {
                localStorage.setItem(
                  "access_token",
                  response.data
                );
                this.loginView=true;
                this.$router.push({
                  path: "./home/main"
                });
              } else {
                this.$message.error(response.data.msg);
              }
            })
            .catch(error => {
              console.log(error);
            })
        }
        if(type == 'wx'){
          wxBindingUser({
              phone: this.form.phone,
              code: this.form.verificationcode,
              state:this.wxState
            }).then(response => {
              console.log(response)
              if (response.code == 200) {
                
              } else {
                this.$message.error(response.data.msg);
              }
            })
            .catch(error => {
              console.log(error);
            })
        }
      },

      changeType(type) {
        this.loginType = type
      },
      
      // 注册
      onRegister() {
        let that=this;
        let data=[];
        if(that.loginType=='wx'){
          data = {
              phone: this.form.phone,
              password: this.form.password,
              code: this.form.verificationcode,
              state:this.wxState
          }
        }else{
          data = {
              phone: this.form.phone,
              password: this.form.password,
              code: this.form.verificationcode,
          }
        }
        registerend(data).then(response => {
            
            if (response.code == 200) {
              if(that.wxBindingBindViewClose){
                  that.loginType = 'password'
                  that.showCode = true
                  that.$message({
                    type: "success",
                    message: "注册成功"
                  });
              }
            }
          })
          .catch(error => {
            console.log(error);
          })
        return;
      },

      onForget() {
      },

      getLoginUrl(){
        let that=this;
        let data = {}
        getLoginUrl(data).then(response => {
            if (response.code == 200) {
               that.wxData=response.data.imginfo;
               that.wxState=response.data.state;
               that.checkState();
            }
          })
          .catch(error => {
            console.log(error);
        })
      },

      checkState(){
        let that=this;
        that.stateTimer = setInterval(() => {
          if(that.loginView){
            clearInterval(that.stateTimer);
          }else{
              that.getTokenByState();
          } 
        }, 5000)
      },

      getTokenByState(){
        let that=this;
        let data = {
          state:that.wxState
        }
        getTokenByState(data).then(response => {
            if (response.code == 200) {

                if(response.data.status==1){
                 
                }
                if(response.data.status==2 && this.wxBindingBindViewClose){
                  that.wxBindingBindViewClose=false;
                  that.wxBindingBindType='register';
                  that.wxBindingDialog=true;
                }
                if(response.data.status==4){
                  clearInterval(that.stateTimer);
                   that.loginView=true;
                   localStorage.setItem(
                      "access_token",
                      response.data.token
                  );
                  this.$router.push({
                    path: "./home/main"
                  });
                }
              }
          })
          .catch(error => {
            console.log(error);
        })
      },

      testCode2(){
        let that=this;
        let data = {}
        testCode2(data).then(response => {
            if (response.code == 200) {
               that.wxData=response.data.imginfo;
               that.wxState=response.data.state;
                setTimeout(function(){ 
                  that.wxBindingBindViewClose=true; 
                }, 1000);
               that.checkState();
            }
          })
          .catch(error => {
            console.log(error);
        })
      },

      closeBinding(){
         this.testCode2();
         this.wxBindingBindType=null;
      },

      getStaff() {
          let data = {};
          getStaff(data)
            .then((response) => {
              this.loading=false;
              if (response.code == 200) {
                localStorage.setItem(
                    "name",response.data.name
                  );
                this.$router.push({
                    path: "./home/enterprise"
                  });
                }
            })
            .catch((error) => {
              console.log(error);
            });
      },

    }
  };
</script>


<style>
  #app,
  body,
  html {
    width: 100%;
    height: 100%;
    overflow: hidden;
  }

  /* 【P117】桌面端登录容器：
     ① 去掉原外链背景图 —— http://test-pc.jixiaoyun.com/... 那台已失效，浏览器回退成 #ccc 灰底，
        把 .login-root 的深蓝渐变整个盖住了（截图实锤：页面是灰色的）；
     ② 去掉 min-width:1360px，避免窄屏横向溢出；
     ③ 改为 flex 居中，让 .login-card 在任意桌面分辨率下都居中。 */
  .Login {
    width: 100%;
    min-height: 100vh;
    background: transparent;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 24px;
    box-sizing: border-box;
  }

  .Login .content {
    width: 1200px;
    height: 600px;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    border-radius: 10px;
    box-shadow: 0 8px 20px 0 rgba(0, 0, 0, .09);
    border: 1px solid rgba(0, 0, 0, .03);
    display: flex;
  }

  .Login .content .content-left {
    width: 670px;
    height: 100%;
    background-color: #fff;
    padding: 15px 80px 0;
    box-sizing: border-box;
  }

  .Login .content .content-left .loginTab {
    margin: 60px 0 40px;
    font-size: 14px;
    font-weight: 400;
    color: #999;
    display: flex;
    align-items: flex-end;
    cursor: pointer;
  }

  .Login .content .content-left .loginTab .select {
    font-size: 24px;
    font-weight: 600;
    color: #333;
  }

  .Login .content .content-left .loginTab span {
    margin: 0 5px;
    line-height: 16px;
  }

  .Login .content .content-left .logininputbox {
    position: relative;
    padding-top: 20px;
  }

  .Login .content .content-left .logininputbox {
    position: relative;
    padding-top: 20px;
  }

  .Login .content .content-left input {
    border-radius: 0;
    border-top: none;
    border-left: none;
    border-right: none;
    padding: 0;
    color: #000;
    background: none;
  }

  .Login .content .content-left .el-button--primary {
    width: 100%;
    height: 50px;
    margin-top: 10px;
    background: linear-gradient(135deg, #2b4c9b 0%, #4a7fe0 100%);
    border: none;
    box-shadow: 0 8px 20px rgba(43, 76, 155, 0.3);
  }

  .Login .content .content-left .yzmtext {
    background: #fff;
    padding: 0 0 0 20px;
    line-height: 30px;
    position: absolute;
    font-size: 16px;
    bottom: 6px;
    right: 2px;
    color: #999;
  }

  .Login .content .content-left .yzmtextblue {
    color: #4a7fe0;
    cursor: pointer;
  }

  .Login .bottom {
    width: 100%;
    font-size: 14px;
    color: #999;
    text-align: center;
    position: absolute;
    bottom: 20px;
    left: 0;
  }

  .Login .content .content-right {
    width: 670px;
    height: 100%;
    text-align: center;
    background: #e6f3ff;
    box-sizing: border-box;
  }

  .Login .content .content-right img {
    width: 100%;
    height: 100%;
  }

  .Login .content .content-right p {
    font-size: 18px;
    line-break: 18px;
    color: #afd2f8;
    letter-spacing: 15px;
    margin-top: 60px;
  }

  .buttons {
    display: flex;
    justify-content: space-between;
  }

  .buttons span {
    cursor: pointer;
    font-size: 16px;
    color: #909399;
  }

  input:-webkit-autofill,
  textarea:-webkit-autofill,
  select:-webkit-autofill {
    -webkit-text-fill-color: #000 !important;
    -webkit-box-shadow: 0 0 0px 1000px transparent inset !important;
    background-color: transparent;
    background-image: none;
    transition: background-color 50000s ease-in-out 0s;
  }

  input {
    background-color: transparent;
  }

 .BindinCode {
    background: #fff;
    padding: 0 0 0 20px;
    line-height: 30px;
    position: absolute;
    font-size: 16px;
    bottom: 6px;
    right: 2px;
    color: #999;
  }

  .BindinCodeBlue {
    color: #4a7fe0;
    cursor: pointer;
    font-size:12px;
    padding:0px 10px 0px 0px;
  }

</style>


<style>
.login-root {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(160deg, #1e3a8a 0%, #2f6bd8 55%, #4a90e2 100%);
  padding: 24px;
  box-sizing: border-box;
  animation: lrFade .35s ease both;
}

@keyframes lrFade {
  from { opacity: 0; }
  to { opacity: 1; }
}

.login-card {
  margin: 0 auto;
  width: 100%;
  max-width: 360px;
  background: #fff;
  border-radius: 20px;
  box-shadow: 0 24px 70px rgba(15, 30, 70, .30);
  padding: 34px 26px 26px;
  box-sizing: border-box;
  animation: lrPop .4s cubic-bezier(.2, .8, .25, 1) both;
}

@keyframes lrPop {
  from { opacity: 0; transform: translateY(18px) scale(.98); }
  to { opacity: 1; transform: translateY(0) scale(1); }
}

.logo {
  text-align: center;
  margin-bottom: 6px;
}
.logo span {
  font-size: 22px;
  font-weight: 700;
  background: linear-gradient(135deg, #2b4c9b 0%, #4a7fe0 100%);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  letter-spacing: 1px;
}

.cl-greeting-m {
  text-align: center;
  font-size: 15px;
  color: #5b6478;
  font-weight: 500;
  margin: 4px 0 20px;
}

.form-item {
  margin-bottom: 16px;
}
.form-item label {
  display: block;
  font-size: 13px;
  color: #5b6478;
  margin-bottom: 8px;
}
.input-wrap {
  width: 100%;
  position: relative;
}
.input-wrap input {
  width: 100%;
  height: 50px;
  padding: 0 14px;
  border: 1px solid #e6e9f0;
  background: #f5f7fb;
  border-radius: 12px;
  font-size: 15px;
  color: #1d2129;
  outline: none;
  box-sizing: border-box;
  transition: border-color .2s, box-shadow .2s, background .2s;
}
.input-wrap input::placeholder {
  color: #aab1c2;
}
.input-wrap input:focus {
  border-color: #4a7fe0;
  background: #eef3ff;
  box-shadow: 0 0 0 3px rgba(74, 127, 224, .18);
}
.eye-icon {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 18px;
  color: #909399;
  cursor: pointer;
  user-select: none;
}
.err-tip {
  font-size: 12px;
  color: #f53f3f;
  margin-top: 4px;
  display: none;
}
.login-card .login-btn {
  width: 100%;
  height: 50px;
  background: linear-gradient(135deg, #2b4c9b 0%, #4a7fe0 100%);
  color: #fff;
  border: none;
  border-radius: 12px;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 2px;
  cursor: pointer;
  margin-top: 8px;
  box-shadow: 0 10px 24px rgba(43, 76, 155, .32);
  transition: opacity .2s;
}
.login-card .login-btn:active {
  opacity: .9;
}
.login-card .login-btn {
  display: block;
}
.login-card .login-btn:disabled {
  background: #a9c0f0;
  cursor: not-allowed;
  box-shadow: none;
}
.link-row {
  display: flex;
  justify-content: space-between;
  margin-top: 14px;
  font-size: 13px;
}
.link-row a {
  color: #4a7fe0;
  text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// src/pages/login.vue